/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FeatureFlag {
    QUICKSIGHT_AUTHORING_ENABLED = 'quicksight_authoring_enabled',
    DATA_MANAGEMENT = 'data_management',
    DATA_MANAGEMENT_V2 = 'data_management_v2',
    SIMPLIFIED_RANGE_ELIGIBILITY_ENABLED = 'simplified_range_eligibility_enabled',
    SURVEY_ORCHESTRATION_CUSTOMER_SURVEY_DOWNLOAD = 'survey_orchestration_customer_survey_download',
    TENANCY_MANAGEMENT = 'tenancy_management',
    ENHANCED_POLICIES = 'enhanced_policies',
    BETTER_AGENTS = 'better_agents',
    MAX_ALLOWED_CUTS_SELECTION = 'max_allowed_cuts_selection',
    PAY_TYPE_GRADE_ENABLED = 'pay_type_grade_enabled',
    PARTICIPATION_JOB_MAPPING = 'participation_job_mapping',
    RANGES_FROM_SCRATCH = 'ranges_from_scratch',
    DIRECT_SURVEY_DATA_ENTRY = 'direct_survey_data_entry',
    AI_CHAT = 'ai_chat',
}
